import { render, staticRenderFns } from "./packing.vue?vue&type=template&id=50f33965&scoped=true&"
import script from "./packing.vue?vue&type=script&lang=js&"
export * from "./packing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f33965",
  null
  
)

export default component.exports